import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyProducts.vue?vue&type=template&id=084f3bde"
import script from "./MoleculeEditionBillingAcademyProducts.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports